<template>
  <div class="moneyExchange" :class="[{ showButton : isShowAllAmount }, lang]">
    <div class="card-header">
        <!-- 顶部卡片 -->
        <div class="account-box">
            <div class="img-box" @click="showAccountPicker = true">
                <img v-if="exchangeInfo.account_type == 1" :src="future" class="img-logo">
                <img v-if="exchangeInfo.account_type == 2" :src="security" class="img-logo">
                <span class="title">{{ exchangeInfo.text }}</span>
                <img :src="bgColor == 'black-theme' ? darkDown : arrowDown " class="icon-arrow">
            </div>
            <div class="hkd-sum">
                <div class="title"> 
                    {{ $t("moneyExchange.m000007") }} 
                    <span class="unit">
                    {{ exchangeInfo.base_currency || '(HKD)' }}
                    </span>
                </div>
                <div class="amount">
                    {{ getAmount(exchangeInfo.base_can_draw) }}
                </div>
            </div>
            <div class="curreny-box">
                <div class="left">
                    <div class="top">{{ $t("moneyExchange.m000008") }}</div>
                    <div class="bottom">{{ getAmount(exchangeInfo.usd_can_draw) }}</div>
                </div>
                <div class="center">
                    <div class="top">{{ $t("moneyExchange.m000009") }}</div>
                    <div class="bottom">{{ getAmount(exchangeInfo.hkd_can_draw) }}</div>
                </div>
                <div class="right">
                    <div class="top">{{ $t("moneyExchange.m000010") }}</div>
                    <div class="bottom">{{ getAmount(exchangeInfo.cnh_can_draw) }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="ipt-box" :class="{error: isClickNext && !formData.amount_out, focus: inputFocusId == 4}">
      <div class="ipt-main">
        <div class="val-box">
          <span class="label" v-if="inputFocusId == 4 || formData.amount_out">{{ $t('moneyExchange.m000003') }}</span>
          <Field
            class="val"
            clearable
            ref="amountField"
            :readonly="formData.is_all == 1"
            :value="displayOutAmount"
            :right-icon="formData.is_all == 1 ? 'clear' : '' "
            :placeholder="inputFocusId == 4 ? '' : $t('moneyExchange.m000003')"
            @focus="inputFocus(4)"
            @blur="inputBlur"
            @input="handleOutAmountInput"
            @click-right-icon="clearAmount"
          ></Field>
        </div>
        <div class="coinType" @click="showPicker(1)">{{ formData.currency_out }}</div>
        <span class="icon-arrow"></span>
      </div>
      <p class="error">{{ $t('fundsTransfer.f000002') }}</p>
    </div>
    <!-- 全部余额 -->
    <div class="tag-btn" :class="{ 'tag-btn-active': formData.is_all == 1 }" v-if="isShowAllAmount" @click="selectedAmount">{{ $t('withdrawNew.lang6') }}</div>
    <div class="ipt-box" :class="{error: isClickNext && !formData.amount_in, focus: inputFocusId == 1}">
      <div class="ipt-main">
        <div class="val-box">
          <span class="label" v-if="inputFocusId == 1 || formData.amount_in">{{ $t('moneyExchange.m000004') }}</span>
          <Field
            class="val"
            v-model="formData.amount_in"
            :placeholder="inputFocusId == 1 ? '' : $t('moneyExchange.m000004')"
            @focus="inputFocus(1)"
            @blur="inputBlur"
            @input="handleInAmountInput"
          ></Field>
        </div>
        <div class="coinType" @click="showPicker(2)">{{ formData.currency_in }}</div>
        <span class="icon-arrow"></span>
      </div>
      <p class="error">{{ $t('fundsTransfer.f000002') }}</p>
    </div>
    <!-- 参考汇率 -->
    <div class="ipt-box" >
        <div class="ipt-main disabled">
            <div class="val-box">
                <div class="box"> 
                    <span class="label">{{ $t('moneyExchange.m000005') }}</span>
                    <span class="label date" v-if="lang != 'en'">{{ formatDate(updated_at) }}{{ $t('moneyExchange.m000006') }}</span>
                    <span class="label date" v-else>{{ $t('moneyExchange.m000006') }} {{ formatDate(updated_at) }}</span>
                </div>
                <Field
                    class="val"
                    :readonly="true"
                    :value="formData.currency && formData.rate ? `${formData.currency}=${formData.rate}` : ''"
                ></Field>
            </div>
        </div>
        <p class="error">{{ $t('fundsTransfer.f000002') }}</p>
    </div>
    <!-- 备注 -->
    <div class="ipt-box" :class="{focus: inputFocusId == 2}">
        <div class="ipt-main">
            <div class="val-box">
            <span class="label" v-if="inputFocusId == 2 || formData.customer_remark">{{ $t('moneyExchange.m000002') }}</span>
            <Field
                class="val"
                v-model="formData.customer_remark"
                :placeholder="inputFocusId == 2 ? '' : $t('moneyExchange.m000002')"
                @focus="inputFocus(2)"
                @blur="inputBlur"
            ></Field>
            </div>
        </div>
        <p class="error">{{ $t('fundsTransfer.f000002') }}</p>
    </div>
    <nav-buttons
        :isFixed="false"
        :showPrev="false"
        :disabled="isButtonDisabled"
        :nextText="$t('bankTransfer.b000016')"
        @on-next="submit"
    />
    <div class="foot-tip">
       <div class="tip-title">
         {{ $t("moneyExchange.m000001[0]") }}
       </div>
       <div class="tip-content">
        {{ $t("moneyExchange.m000001[1]") }}
       </div>
       <div class="tip-content">
        {{ $t("moneyExchange.m000001[2]") }}
       </div>
       <div class="tip-content">
        {{ $t("moneyExchange.m000001[3]") }}
       </div>
     </div>
    <!-- 下拉选择弹窗 -->
    <Popup v-model="showPickerPopup" position="bottom" class="picker-popup picker-ui">
      <Picker show-toolbar :default-index="currentDefaultIndex" :columns="currentColumns" @confirm="onPickerConfirm" @cancel="showPickerPopup = false" />
    </Popup>
    <!-- 账号列表 -->
    <ActionSheet
       :title="$t('withdrawNew.lang')"
       v-model="showAccountPicker"
       class="action-sheet-sex"
     >
       <div>
         <template v-if="accountList.length">
           <div class="sheet-box" v-for="item in accountList" :key="item.account_no" :class="{ 'active-border': item.account_no == exchangeInfo.account_no }" @click="selectAccount(item)">
             <div class="img-box">
               <img :src="item.account_type == 1 ? future : security" class="img-logo">
               <span class="title">{{ item.text }}</span>
             </div>
             <div class="icon-box">
               <Icon :name="rightOK" class="success-icon" size="22" v-if="item.account_no == exchangeInfo.account_no" color="#EA3447"  />
             </div>
           </div>
         </template>
         <div class="empty-box" v-else>
           <img src="@/assets/images/app-pages/recordEmpty.png" alt="no data" class="empty-img">
           <p class="empty-text">{{ $t('bankTransfer.b000019') }}</p>
         </div>
       </div>
    </ActionSheet>
  </div>
</template>

<script>
import { Picker, Popup, Field, ActionSheet, Icon }  from "vant";
import arrowDown from '@/assets/images/arrow-down.png';
import darkDown from '@/assets/images/open-account/dark_icon.png';
import { localeString, validateInput } from '@/utils/utils.new';
import { webViewRightButton } from "@/utils/hybirdMethods";
import future from "@/assets/images/open-account/future.png";
import security from "@/assets/images/open-account/security.png";
import navButtons from '../components/navButtons.vue';
import rightOK from '@/assets/images/app-pages/right_ok.png';
import { formatDate } from '../tools/tools';

export default {
    name: 'moneyExchange',
    components: { 
        Field,
        Picker,
        Popup,
        ActionSheet,
        Icon,
        navButtons
    },
    data() {
        this.currencyList = [];
        this.direction = 0;
        return {
            rightOK,
            arrowDown,
            darkDown,
            future,
            security,
            formData: {
                is_all: 0,
                currency_out: '',
                currency_in: '',
                account: '',
                rate: '',
                amount_in: '',
                amount_out: '',
                customer_remark: '',
                act_method: '',
                currency: '',
                account_type: ''
            },
            showPickerPopup: false,
            outCurrencyList: [],        // 转出币种
            inCurrencyList: [],         // 汇率币种
            inputFocusId: -1,
            isClickNext: false,
            currentColumns: [],
            currentDefaultIndex: 0,
            exchangeInfo: {},
            showAccountPicker: false,
            accountList: [],
            updated_at: '',
            lang: 'zh-CN',    
        } 
    },
    computed: {
        displayOutAmount() {
           return this.formData.is_all == 1 ? this.$t('withdrawNew.lang6') : this.formData.amount_out;
        },
        isShowAllAmount() {
            const balanceMap = {
                'USD': this.exchangeInfo.usd_can_draw,
                'HKD': this.exchangeInfo.hkd_can_draw,
                'CNH': this.exchangeInfo.cnh_can_draw,
            };
            const balance = parseFloat(balanceMap[this.formData.currency_out]);
            return balance > 0;
        },
        bgColor() {
            return this.$store.getters["common/bgColor"];
        },
        formatDate() {
            return dateStr => {
                return formatDate(dateStr);
            }
        },
        isButtonDisabled() {
            // 检查表单数据中的金额是否为空
            if (this.formData.amount_out == '' || this.formData.amount_in == '') {
                return true; // 禁用按钮
            }
            return false; // 启用按钮
        }

    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.formData.account = this.$route.query.account_no;
            this.formData.account_type = this.$route.query.account_type;
            this.getExchangeRate();
            this.getAccountList();
        },
        getExchangeRate() {
            this.$apis.fetchCurrencyRate({ showLoading: true }).then( res => {
                this.currencyList = res.list;
                this.outCurrencyList = this.getUniqueListByField('currency_out');
                this.inCurrencyList = this.getUniqueListByField('currency_in');
                this.formData.currency_out = this.outCurrencyList[0].currency_out;
                this.formData.currency_in = this.inCurrencyList[0].currency_in;
                this.updateExchangeRate(true);
            })
        },
        getUniqueListByField(field) {
            const uniqueObj = {};
            this.currencyList.forEach((item) => {
                const key = item[field];
                if (!uniqueObj[key]) {
                    uniqueObj[key] = {
                        ...item,
                        text: field == 'currency_out' ? item.currency_out : item.currency_in
                    }; 
                }
            });
            return Object.values(uniqueObj);
        },
        // 处理用户输入金额
        handleOutAmountInput(value) {
            this.formData.amount_out = validateInput(value);
            this.$nextTick(() => {
                this.$refs.amountField.$el.querySelector('input').value = validateInput(value);
            });
            this.updateExchangeRate();
            this.convertAmount();
        },
        // 根据汇率进行金额转换，支持双向计算
        convertAmount(fromType = 'out') {
            // out代表换出金额，in代表换入金额
            if (fromType === 'out') {
                // 换出金额为空直接清除换入金额
                if (this.formData.amount_out === '') {
                    this.formData.amount_in = '';
                    return;
                }
                // 输入换出金额自动计算换入金额且direction为1使用乘否则使用除
                this.formData.amount_in = this.direction === 1
                    ? (this.formData.amount_out * this.formData.rate).toFixed(2)
                    : (this.formData.amount_out / this.formData.rate).toFixed(2);
            } else {
                // 换入金额为空直接清除换出金额
                if (this.formData.amount_in === '') {
                    this.formData.amount_out = '';
                    return;
                }
                // 输入换入金额自动计算换出金额且direction为1使用乘否则使用除
                this.formData.amount_out = this.direction === 1
                    ? (this.formData.amount_in / this.formData.rate).toFixed(2)
                    : (this.formData.amount_in * this.formData.rate).toFixed(2);
            }
        },
        handleInAmountInput() {
            this.updateExchangeRate();
            this.convertAmount('in');
        },
        submit() {
            this.isClickNext = true;
            if ( this.isButtonDisabled ) return false;
            if ( this.formData.currency_out == this.formData.currency_in ) {
                this.$toast(this.$t('moneyExchange.m000021'));
                return false;
            }
            this.formData.act_method = this.direction == 1 ? 1 : 2;
            this.$apis.saveExchange(this.formData).then( res => {
                // 去除右上角按钮
                webViewRightButton({
                    isDisplay: false,
                });
                this.$router.push({
                    path: '/app-pages/exchange',
                    query: {
                        account_no: this.formData.account,
                        account_type: this.formData.account_type
                    }
                })
            })
        },
        // 弹出货币选择器，显示对应的货币列表
        showPicker( type ) {
            this.currentColumns = type === 1 ? this.outCurrencyList : this.inCurrencyList;
            this.currentDefaultIndex = this.currentColumns.findIndex(item => 
                type === 1 
                    ? item.currency_out === this.formData.currency_out
                    : item.currency_in === this.formData.currency_in
            );
            this.clickType = type;
            this.showPickerPopup = true;
        },
        selectedAmount() {
            const balanceMap = {
                'USD': this.exchangeInfo.usd_can_draw,
                'HKD': this.exchangeInfo.hkd_can_draw,
                'CNH': this.exchangeInfo.cnh_can_draw,
            };
            // 切换全额选择状态
            this.formData.is_all = this.formData.is_all === 1 ? 0 : 1;
            // 更新输入框状态和金额
            if (this.formData.is_all === 1) {
                this.formData.amount_out = parseFloat(balanceMap[this.formData.currency_out]);
                this.inputFocusId = 4;
            } else {
                this.formData.amount_out = '';
                this.inputFocusId = -1;
            }
            // 转换金额
            this.convertAmount();
        },
        clearAmount() {
            this.formData.is_all = 0;
            this.formData.amount_out = '';
            this.formData.amount_in = '';
            this.inputFocusId = -1;
        },
        getAmount(num){
            return localeString(num)
        },
        // 更新选择的货币种类、汇率，并重新计算金额
        onPickerConfirm(selectedOption) {
            if ( this.clickType == 1 ) {
                this.formData.currency_out = selectedOption.currency_out;
            } else if ( this.clickType == 2 ) {
                this.formData.currency_in = selectedOption.currency_in;
            }
            this.updateExchangeRate(true);
            this.convertAmount();      // 无论是换出还是换入金额的币种切换计算的都是换入的值
            // 选中全部金额的情况下换出币种切换到没有钱的币种清空选中全部金额状态
            if ( this.clickType == 1 && this.formData.is_all == 1 && !this.isShowAllAmount ) {
                this.formData.is_all = 0;
                this.formData.amount_out = '';
                this.formData.amount_in = '';
            }
            this.showPickerPopup = false;
        },
        inputFocus(id){
            this.inputFocusId = id;
        },
        // 更新汇率并设置货币转换使用的是乘还是除，isFromCurrencyChange为true代表币种切换，输入的时候不需要更新汇率
        updateExchangeRate(isFromCurrencyChange = false) {
            const rateData = this.currencyList.find(item => 
                item.currency_out === this.formData.currency_out && 
                item.currency_in === this.formData.currency_in
            );
            this.direction = rateData?.direction ?? 1;
            // 币种切换的情况下才更新
            if (isFromCurrencyChange) {
                this.formData.rate = rateData?.rate ?? 1;
                this.updated_at = rateData?.updated_at ?? this.updated_at;
                this.formData.currency = rateData?.currency ?? `${this.formData.currency_out}/${this.formData.currency_in}`;
            }
        },
        inputBlur() {
            this.inputFocusId = null;
        },
        getAccountList() {
            this.$apis.getAuthList().then(res => {
                if( res ) {
                    const { accountInfo = [] } = res;
                    this.accountList = accountInfo.map( item => {
                        item['text'] = item.account_type == 1 ? 
                                `${this.$t('transferInto.accountName[0]')}\n(${item.account_no})` : 
                                `${this.$t('transferInto.accountName[1]')}\n(${item.account_no})`
                        return item;
                    })
                    this.exchangeInfo = accountInfo.find(item => item.account_no == this.formData.account);
                    this.lang = localStorage.getItem('localLang') || 'zh-CN';
                    this.updateTopRightButton();
                }
            });
        },
        selectAccount( item ) {
            this.exchangeInfo = item;
            this.formData.account = item.account_no;
            this.formData.account_type = item.account_type;
            this.updateTopRightButton();
            this.showAccountPicker = false;
        },
        // 更新右上角按钮信息
        updateTopRightButton() {
            webViewRightButton({
                url: {
                    type: 1,
                    url: `/app-pages/exchange?account_no=${this.formData.account}&account_type=${this.formData.account_type}`
                },
                isDisplay: true,
                title: this.$t('moneyExchange.m000011')
            });
        }
    }
}
</script>

<style lang="less" scoped>
@import '../styles/styles.less';
.moneyExchange {
    padding: 20px 32px;
    .ipt-main {
        .coinType {
            font-size: 28px;
            line-height: 28px;
            color: #17161C;
            margin-right: 12px;
            position: relative; 
            display: inline-block; 
            z-index: 1;
            &::before {
                content: ''; 
                position: absolute; 
                top: -30px; 
                bottom: -30px;
                left: 0px;
                right: -60px; 
                z-index: -1;
            }
        }
        .box {
            display: flex;
            align-items: center;
            .date {
                margin-left: auto;
                color: #F24E1E;
            }
        }
        .icon-arrow {
            transform: translateY(-2px);
        }
        &.disabled {
            background: #F9FAFC;
            /deep/ .van-field__control {
                background-color: #F9FAFC;
            }
        }
        ::v-deep {
            .van-icon {
                margin-top: -52px;
                margin-right: 10px;
            }
            .van-cell {
                overflow: visible !important;
            }
            .van-cell__value {
                overflow: visible !important;
            }
        }
    }
    &.showButton {
        .tag-btn {
            margin-bottom: 16px;
        }
    }
    .card-header {
        margin-bottom: 24px;
    }
}
.black-theme {
    .ipt-main {
        &.disabled {
            background: #14151D !important;
            /deep/ .van-field__control {
                background-color: #14151D !important;
            }
        }
        .coinType {
            color: white;
        }
    }
}
.empty-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
    
    .empty-img {
        width: 130px;
        height: 140px;
    }
    
    .empty-text {
        font-size: 28px;
        color: #747377;
    }
}
</style>